@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container goal-scorer-container triple">
    <div class="option-group-header">
        <span></span>
        @for (player of players; track player) {
            <span> {{ player }} </span>
        }
    </div>
    @for (group of optionGroups; track trackGroup($index, group)) {
        <ng-container *ngTemplateOutlet="optionTemplate; context: { group: group }" />
    }
</div>

<ng-template #optionTemplate let-group="group">
    <div class="attribute-key">
        <span class="attribute-key-ellipsis">{{ group.attribute }}</span>
    </div>
    @for (option of group.options; track trackOption($index, option)) {
        @if (option) {
            <ms-option
                [tracking]="{ source: tracking }"
                [option]="option"
                [optionGroup]="optionGroup"
                [event]="event"
                [sourceOfPick]="sourceOfPick"
                [betDetails]="betDetails" />
        } @else {
            <div class="option">
                <div class="offline option-pick">
                    <div class="value">-</div>
                </div>
            </div>
        }
    }
</ng-template>
